import Vue from 'vue';
import {axiosGet, urlGenerator} from '../../../app/Helpers/AxiosHelper';
import DateFunction from "../../../core/helpers/date/DateFunction";
import * as actions from '../../../app/Config/ApiUrl';
import * as dateTimeFunc from '../../../app/Helpers/DateTimeHelper';
import axios from 'axios';

export default {
    state: {
        selectedEscorter: {},
        photo: '',
        card: '',
    },

    getters: {},

    mutations: {
        GET_ESCORTER(state, escorter) {
            state.selectedEscorter = escorter;

            state.photo = escorter.photo?.full_url ? escorter.photo.full_url : urlGenerator('/images/user.png');
            state.card = escorter.card?.full_url ? escorter.card.full_url : urlGenerator('/images/id-card.png');
        },
    },

    actions: {
        getEscorter({commit}, { escorterId }) {
            axiosGet(`${actions.ESCORTER}/${escorterId}`).then(res => {
                commit('GET_ESCORTER', res.data);
            });
        },
    }
}
